import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'
import About from './views/About.vue'
import Awards from './views/Awards.vue'
import Audios from './views/Audios.vue'
import Photos from './views/Photos.vue'
import Videos from './views/Videos.vue'
import Contacts from './views/Contacts.vue'

Vue.use(Router)

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home
    },
    {
      path: '/about',
      name: 'about',
      component: About
    },
    {
      path: '/awards',
      name: 'awards',
      component: Awards
    },  
    {
      path: '/audio',
      name: 'audio',
      component: Audios
    },
    {
      path: '/gallery',
      name: 'photos',
      component: Photos
    },      
    {
      path: '/video',
      name: 'video',
      component: Videos
    }, 
    {
      path: '/contacts',
      name: 'contacts',
      component: Contacts
    }          
  ]
})
